export default {"src":"https://s.sylndr.com/c-d1764eb/_next/static/media/downloadApp.8585fd5f.gif","height":326,"width":500,"blurWidth":0,"blurHeight":0};